import React from 'react';

import { Avatar, message } from 'antd';

import { useDispatch } from 'react-redux';
import { setCanCancelFriendlyStage, useChat } from '../../../store/slices/chat';

import TitleText from '../../../components/atoms/TitleText';
import Button from '../../../components/atoms/Button';
import { useCancelFriendlyStageMutation } from '../../../store/services/chatService';

const ChatHeader = () => {
  const dispatch = useDispatch();
  const {
    selectedUser,
    SelectedAllUsers,
    isGrouping,
    canCancelFriendlyStage,
    disputeId,
  } = useChat();
  const [cancelFriendlyStage, { isLoading }] = useCancelFriendlyStageMutation();

  const handlecancelFriendlyStage = async () => {
    try {
      await cancelFriendlyStage({ disputeId: disputeId as string }).unwrap();
    } catch (err) {
      //@ts-expect-error
      message.error(err?.message || 'something went wrong');
    }
  };

  const isGroup = isGrouping ?? selectedUser?.isGrouping;
  const currentUsers = SelectedAllUsers?.length
    ? SelectedAllUsers
    : selectedUser?.users;
  const singleUser = currentUsers?.[0];
  const avatarSrc = singleUser?.image;
  const displayName = singleUser?.name || '';

  return (
    <>
      <div className="flex justify-between items-center p-4 border ">
        <div className="flex gap-2 items-center">
          {/* this is the avatar of user that I am chating with him  */}
          {isGroup ? (
            <Avatar.Group
              max={{
                count: 2,
                style: { color: '#f56a00', backgroundColor: '#fde3cf' },
              }}
            >
              {currentUsers?.map((item, index) => (
                <Avatar
                  key={item?.id ?? index}
                  src={item?.image}
                  size={40}
                  className={`${
                    index > 0 ? 'z-10' : 'z-20'
                  } !border-light-success !border-2 !overflow-hidden`}
                />
              ))}
            </Avatar.Group>
          ) : (
            <Avatar
              src={avatarSrc}
              size={58}
              className={` !border-light-success !border-2 !overflow-hidden`}
              alt={displayName || 'avatar'}
            />
          )}
          <div className="flex-col gap-2">
            {isGroup ? (
              <TitleText
                text={
                  currentUsers
                    ?.map((user) => user?.name)
                    ?.filter(Boolean)
                    ?.join(' & ') || ''
                }
              />
            ) : (
              <TitleText text={displayName} />
            )}
          </div>
        </div>
        {canCancelFriendlyStage && (
          <Button
            onClick={handlecancelFriendlyStage}
            variant="outline"
            className="text-base"
            disabled={isLoading}
          >
            {' '}
            Cancel Friendly Stage{' '}
          </Button>
        )}
      </div>
    </>
  );
};

export default ChatHeader;
